module.exports = __webpack_public_path__ + "assets/futurafuturisc-bold-webfont.02276c7c6b98981438c3a18b23c0393e77678f08c32c36eb1f833294467a4ab4.woff2";